interface BaseRedirectLinkContainerProps {
  children: React.ReactNode;
  id?: string;
}

export const BaseRedirectLinkContainer = ({
  children,
  id,
}: BaseRedirectLinkContainerProps) => (
  <span className="text-md line-height-[20px] text-default" {...(id && { id })}>
    {children}
  </span>
);
